/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_GeneratingInputs */

const en_story_bank_generating = /** @type {(inputs: Story_Bank_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating stories...`)
};

const de_story_bank_generating = /** @type {(inputs: Story_Bank_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating stories...`)
};

const fr_story_bank_generating = /** @type {(inputs: Story_Bank_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating stories...`)
};

const es_story_bank_generating = /** @type {(inputs: Story_Bank_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating stories...`)
};

const it_story_bank_generating = /** @type {(inputs: Story_Bank_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating stories...`)
};

const nl_story_bank_generating = /** @type {(inputs: Story_Bank_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating stories...`)
};

const pl_story_bank_generating = /** @type {(inputs: Story_Bank_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating stories...`)
};

const fi_story_bank_generating = /** @type {(inputs: Story_Bank_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating stories...`)
};

const da_story_bank_generating = /** @type {(inputs: Story_Bank_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating stories...`)
};

const sv_story_bank_generating = /** @type {(inputs: Story_Bank_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating stories...`)
};

/**
* | output |
* | --- |
* | "Generating stories..." |
*
* @param {Story_Bank_GeneratingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_generating = /** @type {((inputs?: Story_Bank_GeneratingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_GeneratingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_generating(inputs)
	if (locale === "fr") return fr_story_bank_generating(inputs)
	if (locale === "es") return es_story_bank_generating(inputs)
	if (locale === "it") return it_story_bank_generating(inputs)
	if (locale === "nl") return nl_story_bank_generating(inputs)
	if (locale === "pl") return pl_story_bank_generating(inputs)
	if (locale === "fi") return fi_story_bank_generating(inputs)
	if (locale === "da") return da_story_bank_generating(inputs)
	if (locale === "sv") return sv_story_bank_generating(inputs)
	return en_story_bank_generating(inputs)
});